export const DATE_FORMAT = 'D. M. YYYY'
export const DATETIME_FORMAT = 'DD.MM.YYYY HH:mm:ss'

export const skSelectOption = {
  id: 210,
  kodZdroj: '703',
  nazov: 'Slovenská republika',
}

export const menaEuroOption = {
  id: 9,
  kodZdroj: 'EUR',
  nazov: 'Euro',
}

export const BACKEND_DATE_FORMAT = 'YYYY-MM-DDTHH:mm:ssZ'
// BE obcas nevyplni zonu (+00:00), a to sa nam ulozi do vee-validate. Toto je taky ohack ako to naparsovat
// a znovu formatovat tym BACKEND_DATE_FORMAT formatom. VId dateinput separated
export const BACKEND_DATE_FORMAT_2 = 'YYYY-MM-DDTHH:mm:ss[Z]'

/**
 * Formát v ktorom príde default hodnota pre pole "Dátum a čas" v dynosekcii.
 */
export const IS_DATETIME_FORMAT = 'YYYY-MM-DDTHH:mm:ss.SSS[Z]'

export const DATE_FORMAT_STRING = 'YYYY-MM-DD'

/** 24-hour format */
export const TIME_FORMAT_STRING = 'HH:mm'

/** File max size */
export const MAX_FILE_SIZE_MB = 100
